import styled from "styled-components"

export const VideoDuration = styled.div`
  color: ${(props) => props.theme.colors.podcasts};
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.2rem;
`

export const BottomRightPlayIcon = styled.div`
  padding: 1.5rem 1rem 1rem 1.9rem;
  border-radius: 100% 0 0 0;
  background: #fff;

  ::after {
    content: "";
    display: block;

    width: 0;
    height: 0;
    border-top: 0.7rem solid transparent;
    border-bottom: 0.7rem solid transparent;
    border-left: 1.2rem solid #bbbbbb;
  }
`
